import { getItem } from 'common/api/panels';
import { setDatasheetData } from 'common/modules/productDatasheet/actions';

import {
    FETCH_ITEM_DETAIL,
    FETCH_ITEM_DETAIL_FAILURE,
    FETCH_ITEM_DETAIL_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import initializeForm from './initializeForm';
import resetForm from './resetForm';
import setEnabledEdition from './setEnabledEdition';
import setIsNewRecord from './setIsNewRecord';
import toggleProductForm from './toggleProductForm';

export default (item) => (dispatch) => {
    dispatch(actions[FETCH_ITEM_DETAIL]());
    dispatch(resetForm());
    dispatch(toggleProductForm(true));

    getItem(item.id)
        .then(async (response) => {
            const { data } = response;

            dispatch(actions[FETCH_ITEM_DETAIL_SUCCESS](data));

            const datasheet = {
                created_at: data.created_at,
                data_sheet: data.data_sheet,
                data_sheet_name: data.data_sheet_name,
                datasheet_archive: data.data_sheet,
                datasheet_name: data.data_sheet_name,
                updated_at: data.updated_at,
            };

            let values = {
                ...data,
                ...datasheet,
            };

            dispatch(setDatasheetData(datasheet));

            dispatch(setIsNewRecord(false));
            dispatch(initializeForm(values));
            dispatch(setEnabledEdition(false));
        })
        .catch((error) => {
            dispatch(
                actions[FETCH_ITEM_DETAIL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            dispatch(toggleProductForm(false));
        });
};
